import dynamic from 'next/dynamic'
import Head from 'next/head'
import { useEffect } from 'react'
import { useFetch } from 'use-http'
import { API_URL } from '../constants/api'
import { useWeb3Auth } from '../services/web3auth'
import useAuthStore from '../store/authStore'
import useUploadStore from '../store/uploadStore'
const ItemOfTheDay = dynamic(
  () => import('../components/discover/ItemOfTheDay')
)
const FeaturedNFT = dynamic(() => import('../components/discover/FeaturedNFT'))
const Trending = dynamic(() => import('../components/discover/Trending'))

const Alteros = (props: any) => {
  const { get, post, data, error } = useFetch(
    `${API_URL}/app/featuredNfts`,
    { method: 'POST' },
    []
  )

  const { logError, account } = props
  const { setCurrentUser, setOpenLogginDetails } = useAuthStore()
  const { logout } = useWeb3Auth()

  useEffect(() => {
    const typeofLogin = localStorage.getItem('Web3Auth-cachedAdapter')
    const user_id = localStorage.getItem('uid')
    if (typeofLogin == 'metamask') {
      console.log('HI')
      if (user_id && account) {
        console.log('Account changed', account)
        // console.log(user_id?.toLowerCase() != account?.toLowerCase())
        // console.log(user_id?.toLowerCase())
        // console.log(account?.toLowerCase())
        if (user_id?.toLowerCase() != account?.toLowerCase()) {
          logout()
          setCurrentUser(null)
          setOpenLogginDetails(null)
        }
      }
    }
  }, [account])

  const { getCurrentUser } = useAuthStore()
  const { getCategoryList } = useUploadStore()

  useEffect(() => {
    getCurrentUser()
    getCategoryList()
  }, [])

  return (
    <div className="mx-auto flex w-[94%] flex-col items-center justify-start md:w-[95%] ">
      <Head>
        <meta property="og:title" content="Alter | Portal to metaverse" />
        <title>Alter | Portal to metaverse</title>
      </Head>

      <div className="grid-row-2 grid w-full items-stretch gap-4 md:grid-cols-3">
        <FeaturedNFT featured={data?.data?.featured_nfts} />
        <ItemOfTheDay todayItem={data?.data?.top_rated} />
      </div>

      <Trending />
    </div>
  )
}

export default Alteros
